import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPlan, IPlansRules } from "../../api/plans/index.types";

export interface PlansState {
  data: {
    plans: IPlan[];
    plans_rules: IPlansRules[];
  };
  loading: boolean;
}

const initialState: PlansState = {
  data: {
    plans: [],
    plans_rules: [],
  },
  loading: true,
};

interface FetchSuccessPayload {
  plans: IPlan[];
  plans_rules: IPlansRules[];
}

const index = createSlice({
  name: "plans",
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state, action: PayloadAction<FetchSuccessPayload>) => {
      state.data.plans = action.payload.plans;
      state.data.plans_rules = action.payload.plans_rules;
      state.loading = false;
    },
    fetchFailed: (state) => {
      state.loading = false;
    },
  },
});

export const plansActions = index.actions;
export default index.reducer;
